webpackJsonp([100095027350696],{

/***/ 2563:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/step-1.2ce7aea9.png";

/***/ }),

/***/ 726:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Quickstart = __webpack_require__(9);
	
	var _Quickstart2 = _interopRequireDefault(_Quickstart);
	
	var _Markdown = __webpack_require__(5);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	var _CodeTabs = __webpack_require__(7);
	
	var _CodeTabs2 = _interopRequireDefault(_CodeTabs);
	
	var _CodeTab = __webpack_require__(6);
	
	var _CodeTab2 = _interopRequireDefault(_CodeTab);
	
	var _QuickstartBranch = __webpack_require__(8);
	
	var _QuickstartBranch2 = _interopRequireDefault(_QuickstartBranch);
	
	var _step = __webpack_require__(2563);
	
	var _step2 = _interopRequireDefault(_step);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _Quickstart2.default,
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'Step 1: Add Filter Component'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'In this step we\'ll add a Filter component to our interface.'
	    ),
	    _react2.default.createElement(_QuickstartBranch2.default, { branch: 'filtering.1' }),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Add Filter Component'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Create a component called ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'Filter'
	      ),
	      '. We\'ll be using this component to display a list of links the user can click to filter the data being displayed.'
	    ),
	    _react2.default.createElement(_Markdown2.default, { type: 'sh', text: '\n      lore generate component Filter\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Update the code to look like this:'
	    ),
	    _react2.default.createElement(
	      _CodeTabs2.default,
	      null,
	      _react2.default.createElement(_CodeTab2.default, { syntax: 'ES5', text: '\n        import React from \'react\';\n        import createReactClass from \'create-react-class\';\n        import PropTypes from \'prop-types\';\n        import { Link, IndexLink } from \'react-router\';\n\n        export default createReactClass({\n          displayName: \'Filter\',\n\n          contextTypes: {\n            user: PropTypes.object.isRequired\n          },\n\n          render() {\n            const { user } = this.context;\n\n            return (\n              <div className="filter">\n                <ul className="list-group">\n                  <IndexLink className="list-group-item" activeClassName="active" to="/">\n                    Feed\n                  </IndexLink>\n                  <Link className="list-group-item" activeClassName="active" to={"/users/" + user.id}>\n                    My Tweets\n                  </Link>\n                </ul>\n              </div>\n            );\n          }\n\n        });\n        ' }),
	      _react2.default.createElement(_CodeTab2.default, { syntax: 'ES6', text: '\n        import React from \'react\';\n        import PropTypes from \'prop-types\';\n        import { Link, IndexLink } from \'react-router\';\n\n        class Filter extends React.Component {\n\n          render() {\n            const { user } = this.context;\n\n            return (\n              <div className="filter">\n                <ul className="list-group">\n                  <IndexLink className="list-group-item" activeClassName="active" to="/">\n                    Feed\n                  </IndexLink>\n                  <Link className="list-group-item" activeClassName="active" to={"/users/" + user.id}>\n                    My Tweets\n                  </Link>\n                </ul>\n              </div>\n            );\n          }\n\n        }\n\n        Filter.contextTypes = {\n          user: PropTypes.object.isRequired\n        };\n\n        export default Filter;\n        ' }),
	      _react2.default.createElement(_CodeTab2.default, { syntax: 'ESNext', text: '\n        import React from \'react\';\n        import PropTypes from \'prop-types\';\n        import { Link, IndexLink } from \'react-router\';\n\n        class Filter extends React.Component {\n\n          static contextTypes = {\n            user: PropTypes.object.isRequired\n          };\n\n          render() {\n            const { user } = this.context;\n\n            return (\n              <div className="filter">\n                <ul className="list-group">\n                  <IndexLink className="list-group-item" activeClassName="active" to="/">\n                    Feed\n                  </IndexLink>\n                  <Link className="list-group-item" activeClassName="active" to={"/users/" + user.id}>\n                    My Tweets\n                  </Link>\n                </ul>\n              </div>\n            );\n          }\n\n        }\n\n        export default Filter;\n        ' })
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'In the code above, we\'ve added two links; one to display all tweets (the Feed) and one to display only the tweets belonging to a specific user. In this case, we\'re going to call that link "My Tweets" and use it to display the current user\'s tweets.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Update Layout'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'With our ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'Filter'
	      ),
	      ' component created, import it into the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'Layout'
	      ),
	      ' component and insert it right below the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'Profile'
	      ),
	      ':'
	    ),
	    _react2.default.createElement(
	      _CodeTabs2.default,
	      null,
	      _react2.default.createElement(_CodeTab2.default, { syntax: 'ES5', text: '\n        // src/components/Layout.js\n        ...\n        import Filter from \'./Filter\';\n\n        export default createReactClass({\n          displayName: \'Layout\',\n\n          render() {\n            return (\n              <div>\n                <Header />\n                <div className="container">\n                  <div className="row">\n                    <div className="col-md-3">\n                      <Profile />\n                      <Filter />\n                    </div>\n                    <div className="col-md-offset-1 col-md-6">\n                      {React.cloneElement(this.props.children)}\n                    </div>\n                  </div>\n                </div>\n              </div>\n            );\n          }\n\n        });\n        ' }),
	      _react2.default.createElement(_CodeTab2.default, { syntax: 'ES6', text: '\n        // src/components/Layout.js\n        ...\n        import Filter from \'./Filter\';\n\n        class Layout extends React.Component {\n\n          render() {\n            return (\n              <div>\n                <Header />\n                <div className="container">\n                  <div className="row">\n                    <div className="col-md-3">\n                      <Profile />\n                      <Filter />\n                    </div>\n                    <div className="col-md-offset-1 col-md-6">\n                      {React.cloneElement(this.props.children)}\n                    </div>\n                  </div>\n                </div>\n              </div>\n            );\n          }\n\n        }\n        ...\n        ' }),
	      _react2.default.createElement(_CodeTab2.default, { syntax: 'ESNext', text: '\n        // src/components/Layout.js\n        ...\n        import Filter from \'./Filter\';\n\n        class Layout extends React.Component {\n\n          render() {\n            return (\n              <div>\n                <Header />\n                <div className="container">\n                  <div className="row">\n                    <div className="col-md-3">\n                      <Profile />\n                      <Filter />\n                    </div>\n                    <div className="col-md-offset-1 col-md-6">\n                      {React.cloneElement(this.props.children)}\n                    </div>\n                  </div>\n                </div>\n              </div>\n            );\n          }\n\n        }\n        ...\n        ' })
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'If you refresh the page you should now see the Filter displayed right below the Profile. Clicking on a link will generate a console error however, as the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        '/users/:userId'
	      ),
	      ' route doesn\'t exist yet. We\'ll fix that next.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Visual Check-in'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'If everything went well, your application should now look like this.'
	    ),
	    _react2.default.createElement('img', { className: 'drop-shadow', src: _step2.default }),
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Code Changes'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Below is a list of files modified during this step.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'src/components/Filter.js'
	    ),
	    _react2.default.createElement(
	      _CodeTabs2.default,
	      null,
	      _react2.default.createElement(_CodeTab2.default, { syntax: 'ES5', text: '\n        import React from \'react\';\n        import createReactClass from \'create-react-class\';\n        import PropTypes from \'prop-types\';\n        import { Link, IndexLink } from \'react-router\';\n\n        export default createReactClass({\n          displayName: \'Filter\',\n\n          contextTypes: {\n            user: PropTypes.object.isRequired\n          },\n\n          render() {\n            const { user } = this.context;\n\n            return (\n              <div className="filter">\n                <ul className="list-group">\n                  <IndexLink className="list-group-item" activeClassName="active" to="/">\n                    Feed\n                  </IndexLink>\n                  <Link className="list-group-item" activeClassName="active" to={"/users/" + user.id}>\n                    My Tweets\n                  </Link>\n                </ul>\n              </div>\n            );\n          }\n\n        });\n        ' }),
	      _react2.default.createElement(_CodeTab2.default, { syntax: 'ES6', text: '\n        import React from \'react\';\n        import PropTypes from \'prop-types\';\n        import { Link, IndexLink } from \'react-router\';\n\n        class Filter extends React.Component {\n\n          render() {\n            const { user } = this.context;\n\n            return (\n              <div className="filter">\n                <ul className="list-group">\n                  <IndexLink className="list-group-item" activeClassName="active" to="/">\n                    Feed\n                  </IndexLink>\n                  <Link className="list-group-item" activeClassName="active" to={"/users/" + user.id}>\n                    My Tweets\n                  </Link>\n                </ul>\n              </div>\n            );\n          }\n\n        }\n\n        Filter.contextTypes = {\n          user: PropTypes.object.isRequired\n        };\n\n        export default Filter;\n        ' }),
	      _react2.default.createElement(_CodeTab2.default, { syntax: 'ESNext', text: '\n        import React from \'react\';\n        import PropTypes from \'prop-types\';\n        import { Link, IndexLink } from \'react-router\';\n\n        class Filter extends React.Component {\n\n          static contextTypes = {\n            user: PropTypes.object.isRequired\n          };\n\n          render() {\n            const { user } = this.context;\n\n            return (\n              <div className="filter">\n                <ul className="list-group">\n                  <IndexLink className="list-group-item" activeClassName="active" to="/">\n                    Feed\n                  </IndexLink>\n                  <Link className="list-group-item" activeClassName="active" to={"/users/" + user.id}>\n                    My Tweets\n                  </Link>\n                </ul>\n              </div>\n            );\n          }\n\n        }\n\n        export default Filter;\n        ' })
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'src/components/Layout.js'
	    ),
	    _react2.default.createElement(
	      _CodeTabs2.default,
	      null,
	      _react2.default.createElement(_CodeTab2.default, { syntax: 'ES5', text: '\n        import React from \'react\';\n        import createReactClass from \'create-react-class\';\n        import PropTypes from \'prop-types\';\n        import Header from \'./Header\';\n        import Profile from \'./Profile\';\n        import Filter from \'./Filter\';\n\n        export default createReactClass({\n          displayName: \'Layout\',\n\n          render() {\n            return (\n              <div>\n                <Header />\n                <div className="container">\n                  <div className="row">\n                    <div className="col-md-3">\n                      <Profile />\n                      <Filter />\n                    </div>\n                    <div className="col-md-offset-1 col-md-6">\n                      {React.cloneElement(this.props.children)}\n                    </div>\n                  </div>\n                </div>\n              </div>\n            );\n          }\n\n        });\n        ' }),
	      _react2.default.createElement(_CodeTab2.default, { syntax: 'ES6', text: '\n        import React from \'react\';\n        import PropTypes from \'prop-types\';\n        import Header from \'./Header\';\n        import Profile from \'./Profile\';\n        import Filter from \'./Filter\';\n\n        class Layout extends React.Component {\n\n          render() {\n            return (\n              <div>\n                <Header />\n                <div className="container">\n                  <div className="row">\n                    <div className="col-md-3">\n                      <Profile />\n                      <Filter />\n                    </div>\n                    <div className="col-md-offset-1 col-md-6">\n                      {React.cloneElement(this.props.children)}\n                    </div>\n                  </div>\n                </div>\n              </div>\n            );\n          }\n\n        }\n\n        export default Layout;\n        ' }),
	      _react2.default.createElement(_CodeTab2.default, { syntax: 'ESNext', text: '\n        import React from \'react\';\n        import PropTypes from \'prop-types\';\n        import Header from \'./Header\';\n        import Profile from \'./Profile\';\n        import Filter from \'./Filter\';\n\n        class Layout extends React.Component {\n\n          render() {\n            return (\n              <div>\n                <Header />\n                <div className="container">\n                  <div className="row">\n                    <div className="col-md-3">\n                      <Profile />\n                      <Filter />\n                    </div>\n                    <div className="col-md-offset-1 col-md-6">\n                      {React.cloneElement(this.props.children)}\n                    </div>\n                  </div>\n                </div>\n              </div>\n            );\n          }\n\n        }\n\n        export default Layout;\n        ' })
	    ),
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Next Steps'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'In the next section we\'ll add the ability to ',
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '../step-2/' },
	        'view just the user\'s tweets'
	      ),
	      '.'
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-quickstart-filtering-step-1-js-a2e4bb0b659e18b1afa8.js